"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
(0, jquery_1.default)(function () {
    var $teachersContainer = (0, jquery_1.default)('.teachers-shortcode');
    if (!$teachersContainer.length) {
        return;
    }
    var $teachers = $teachersContainer.find(".teacher");
    $teachers.find(".header").on("click", function () {
        var $header = (0, jquery_1.default)(this);
        var $teacher = $header.parent();
        var $content = $teacher.find(".content");
        var $icon = $header.find(".icon i");
        $icon.removeClass("fa-chevron-up");
        $icon.removeClass("fa-chevron-down");
        if ($content.is(":visible")) {
            $content.hide();
            $icon.addClass("fa-chevron-down");
        }
        else {
            $content.show();
            $icon.addClass("fa-chevron-up");
        }
    });
});
